import React, { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Footer from "../../../../containers/Footer";
import { APP_ERRORS } from "../../../../config/appErrors";
import { APP_CONST } from "../../../../config/const";
import { addPlayerBankDetails } from "../../../../redux/user/actions";
import { Toaster } from "../../../../utils/toaster";
import BankDetails from "./bankDetails";
import BankDetailsForm from "./bankDetailsForm";
import { encryptData, decryptData } from "../../../../utils/encryptUtils";
import {
  getPlayerBankDetails,
  updatePlayerBankDetails,
  detelePlayerBankRecord,
} from "../../../../redux/user/actions";
import { generateQueryParams } from "../../../../utils/generateQueryParams";
import { isValidJson } from "../../../../utils/validatorUtils";
import usePaginationHook from "../../../../hooks/usePaginationHook";
import { useDispatch, useSelector } from "react-redux";
const PlayerBankDetailsForm = () => {
  const pagination = usePaginationHook({});
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const { bankDetails } = useSelector((state) => state.user);
  const [decryptedBank, setDecryptedBank] = useState({
    banks: [],
    count: 0,
    pagesize: 10,
  });
  useEffect(() => {
    if (bankDetails) {
      const decryptedData = decryptData({
        data: bankDetails?.banks || "",
        key: localStorage.getItem("token"),
      });
      setDecryptedBank({
        banks: isValidJson(decryptedData) ? JSON.parse(decryptedData) : [],
        count: bankDetails.count,
        pagesize: bankDetails.pagesize,
      });
    }
  }, [bankDetails]);
  useEffect(() => {
    fetchInitialData();
  }, []);
  const fetchInitialData = async () => {
    const query = generateQueryParams({ ...pagination.apiParams });
    dispatch(getPlayerBankDetails(query));
  };

  const handleSubmit = async (bankData) => {
    let encryptedData = "";
    if (bankData?.type === APP_CONST.PLAYER_BANK_DETAILS_TYPE.Bank) {
      encryptedData = encryptData({
        data: JSON.stringify({
          ...bankData,
          // accountNumber: parseFloat(bankData.accountNumber),
        }),
        key: localStorage.getItem("token"),
      });
    } else {
      encryptedData = encryptData({
        data: JSON.stringify({
          ...bankData,
          cardNo: parseFloat(bankData?.cardNo),
          expiryMonth: parseFloat(bankData?.expiryMonth),
          expiryYear: parseFloat(bankData?.expiryYear),
          cvv: parseFloat(bankData?.cvv),
        }),
        key: localStorage.getItem("token"),
      });
    }

    setIsLoading(true);
    const details = await addPlayerBankDetails({ data: encryptedData });
    if (details?.data.error == false) {
      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Bank details added");
      fetchInitialData();
      // setTimeout(() => {
      //   window.location.reload();
      // }, [1000]);
      // console.log("decryptedData", decryptedData);
    }
    setIsLoading(false);
  };

  return (
    <>
      <div className="WithDrawBankDetails">
        <div className="">
          <div className="heading">{"Bank Transfer"}</div>
          <BankDetailsForm handleSubmit={handleSubmit} isLoading={isLoading} />
        </div>
        <BankDetails
          fetchInitialData={fetchInitialData}
          bankDetails={decryptedBank}
        />
      </div>
    </>
  );
};
export default PlayerBankDetailsForm;
